const dependencyMessage = {
	critical_illness:
		"You are ineligible for Critical Illness WITH CANCER Coverage Level as you have already enrolled for Cancer Plan.Either waive cancer plan or proceed without With Cancer Coverage Level"
};

export const DEPENDENCY_MESSAGE = dependencyMessage;
